import { format } from 'date-fns'

export const downloadFile = ({
  data,
  downloadName,
  csvFormat = false,
}: {
  data: Blob
  downloadName: string
  csvFormat?: boolean
}) => {
  const formattedDate = format(new Date(), 'yyyy MM dd')
  const fileName = `NET PURPOSE - ${downloadName} - ${formattedDate}${csvFormat ? '.csv' : '.xlsx'}`
  const downloadURL = URL.createObjectURL(data)
  const a = document.createElement('a')
  a.href = downloadURL
  a.download = fileName
  a.click()
  URL.revokeObjectURL(downloadURL)
}
